/** Suchalarm aus einer SEO-Einstiegsseite — ohne stille Versprechen. */
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BellPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { createSavedSearch } from "../../api/savedSearchesApi";
import { useAuth } from "../../auth/AuthContext";
import { seoAlertPayload } from "../../seo/landing";

export const SeoAlertButton = ({ page, lang, path }) => {
  const { t } = useTranslation(["seo"]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    const { vertical, name, filters, dropped } = seoAlertPayload(page, lang);
    if (!user) {
      toast.info(t("seo:alert.guest"));
      navigate(`/register?next=${encodeURIComponent(path)}`);
      return;
    }
    setBusy(true);
    try {
      await createSavedSearch({ vertical, name, filters });
      toast.success(
        dropped.length
          ? t("seo:alert.savedPartial", { name })
          : t("seo:alert.saved", { name }),
      );
    } catch (err) {
      const msg = err?.response?.data?.error?.message;
      toast.error(msg ? `${t("seo:alert.failed")} ${msg}` : t("seo:alert.failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        data-testid="seo-alert-cta"
        onClick={onClick}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-xl border border-emerald-500/60 bg-emerald-500/10 px-4 py-2.5 text-sm font-semibold text-emerald-300 transition-colors hover:border-emerald-400 hover:bg-emerald-500/20 disabled:opacity-60"
      >
        {busy ? <Loader2 size={14} className="animate-spin" aria-hidden />
          : <BellPlus size={14} aria-hidden />}
        {t("seo:alert.cta")}
      </button>
      <span className="text-xs text-zinc-500">{t("seo:alert.hint")}</span>
      {user && (
        <Link to="/alerts" data-testid="seo-alert-manage"
          className="text-xs text-zinc-400 underline hover:text-zinc-200">
          {t("seo:alert.manage")}
        </Link>
      )}
    </div>
  );
};

export default SeoAlertButton;
